Vue.component('products-table', () => import(/* webpackChunkName: "products-table" */ '@modulesPages/Product/Resources/assets/js/Tables/ProductsTable'))

Vue.component('products-form', () => import(/* webpackChunkName: "products-form" */ '@modulesPages/Product/Resources/assets/js/Forms/Products/ProductsForm'))

Vue.component('products-card', () => import(/* webpackChunkName: "products-card" */ '@modulesPages/Product/Resources/assets/js/Cards/ProductsCard'))

Vue.component('new-products-section', () => import(/* webpackChunkName: "new-products-section" */ '@modulesPages/Product/Resources/assets/js/Sections/NewProductsSection'))



Vue.component('products-section', () => import(/* webpackChunkName: "products-section" */ '@modulesPages/Product/Resources/assets/js/Sections/ProductsSection'))
Vue.component('products-card2', () => import(/* webpackChunkName: "products-card2" */ '@modulesPages/Product/Resources/assets/js/Cards/ProductsCard2'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Product\\Entities\\Product': 'Producto',
    }   
}

app.$Util.tableNameByClassName = {
    ...app.$Util.tableNameByClassName,
    ...{
        'Modules\\Product\\Entities\\Product': 'products',
    }   
}

app.$Util.classNameByTableName = {
    ...app.$Util.classNameByTableName,
    ...{
        'products': 'Modules\\Product\\Entities\\Product',
    }   
}

app.$Util.getFormattedMeasureUnit = function(measureUnit) {
    switch(measureUnit) {
        case 'MGM':
            measureUnit = 'Miligramos'
        break

        case 'GRM':
            measureUnit = 'Gramos'
        break

        case 'KGM':
            measureUnit = 'Kilogramos'
        break

        case 'MLT':
            measureUnit = 'Mililitros'
        break

        case 'LTR':
            measureUnit = 'Litros'
        break

        case 'XPK':
            measureUnit = 'Paquete'
        break

        case 'H87':
            measureUnit = 'Unidad'
        break
    }

    return measureUnit
}